import './index.css';
import React from 'react';
import ScreenBackground from '../screen_background';
import I18 from '../../utilities/locale';
import Constants from '../../constants';
import useTheme from '../../utilities/hooks/theme';
import View from '../view';
import Text from '../text';
import { Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { pingServer, setServerDown } from '../../actions/app-actions-types';

const ServerDown = () => {
  const { ComponentTheme } = useTheme();
  const dispatch = useDispatch();

  const onPressTryAgain = () => {
    dispatch(
      pingServer({
        data: {},
        callback: ({ error, result }: { error: any; result: any }) => {
          if (!error && result) {
            const { status = '' } = result;
            if (status === 'UP') {
              dispatch(setServerDown(false));
            }
          } else {
            const { statusCode = '', status = '' } = error;
            if (
              (statusCode && (statusCode === 502 || statusCode === 503)) ||
              (status && (status === 502 || status === 503))
            ) {
              dispatch(setServerDown(true));
            } else {
              dispatch(setServerDown(false));
            }
          }
        }
      })
    );
  };

  const headerContainerColor = {
    backgroundColor: ComponentTheme.serverDownHeader
  };
  const iGamioTitle = {
    color: ComponentTheme.serverDownHeaderTitle
  };
  const serverDownContent = {
    color: ComponentTheme.serverDownContent
  };
  const tryAgainButton = {
    backgroundColor: ComponentTheme.serverDownButtonBG,
    color: ComponentTheme.serverDownButtonTitle
  };
  return (
    <ScreenBackground>
      <View style={headerContainerColor} className={'server-down-logo'}>
        <Constants.Svgs.IGamioLogo width={35} height={45} fill={'transparent'} />
        <Text style={iGamioTitle} className={'server-down-iGamioTitle'}>
          {'iGamio'}
        </Text>
      </View>
      <View className="server-down-subContainer">
        <img src={Constants.Images.Oops} width={'180px'} height={'200px'} />
        <Text style={serverDownContent} className={'server-down-content'}>
          {I18.t('serverDownMessage')}
        </Text>
        <Button
          style={tryAgainButton}
          onClick={onPressTryAgain}
          className="server-down-buttonLabel">
          {I18.t('TryAgain')}
        </Button>
      </View>
    </ScreenBackground>
  );
};

export default React.memo(ServerDown);
